import { useQueryClient } from "react-query";
import { t } from "@/i18n-js/instance";
import { useToast } from "@/react/components/shared/uikit/ToastV2";
import { useAcceptConnection } from "@/react/hooks/connections/useAcceptConnection";
import { invalidateAllMemberQueries } from "./util";

export const useAcceptConnectionForUser = ({
  memberPublicUid,
  memberName,
  onSuccess,
}: {
  memberPublicUid?: string;
  memberName?: string;
  onSuccess?: () => void;
}) => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const { mutate: acceptConnection, isLoading: isAccepting } =
    useAcceptConnection({
      onSuccess: async () => {
        await invalidateAllMemberQueries(queryClient, memberPublicUid ?? "");
        toast.success(
          t("profile_drawer.connect_banner.messages.connection_accepted", {
            memberName,
          }),
        );
        onSuccess?.();
      },
      onError: () => {
        toast.error(
          t("profile_drawer.connect_banner.messages.connection_accept_error"),
        );
      },
    });

  return {
    acceptConnectionForUser: acceptConnection,
    isAccepting,
  };
};
